import moment from "moment";
import trans from '@astina/paloma-common-ui/src/services/Translator';
export function useUnavailabilityReason() {
    function getUnavailabilityReason(availability) {
        if (!availability) {
            return trans("product.no_variants_available");
        }
        const reasons = availability.unavailabilityReasons;
        if (!reasons || reasons.length === 0) {
            return trans("product.no_variants_available");
        }
        const now = new Date();
        for (const reason of reasons) {
            if (reason === "interrupted" && availability.interruptions) {
                const interruptions = availability.interruptions;
                //find interruption that applies now
                const currentInterruption = interruptions.find((intr) => {
                    const from = intr.interruptedFrom ? new Date(intr.interruptedFrom) : null;
                    const to = intr.interruptedTo ? new Date(intr.interruptedTo) : null;
                    const started = !from || now >= from;
                    const notEnded = !to || now <= to;
                    return started && notEnded;
                });
                if (currentInterruption) {
                    const from = currentInterruption.interruptedFrom
                        ? moment(currentInterruption.interruptedFrom)
                        : null;
                    const to = currentInterruption.interruptedTo
                        ? moment(currentInterruption.interruptedTo)
                        : null;
                    const format = (m) => m.format('DD.MM.YYYY');
                    if (from && to) {
                        return trans('product.interrupted.from_to', { from: format(from), to: format(to) });
                    }
                    if (from && !to) {
                        return trans('product.interrupted.from', { from: format(from) });
                    }
                    if (!from && to) {
                        return trans('product.interrupted.to', { to: format(to) });
                    }
                    return trans('product.interrupted');
                }
            }
        }
        //default
        return trans('product.' + reasons[0]);
    }
    return {
        getUnavailabilityReason,
    };
}
